<template>
  <div class="kalem">
    <onaydialog ref="onaydialog"></onaydialog>
    <loadingcomp v-model="denemestatus"></loadingcomp>
    <hatadialog ref="hatadialog"></hatadialog>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <faturaheaderdialog ref="faturaheaderdialog"></faturaheaderdialog>


    <v-card color="grey lighten-4" flat>

      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>{{$t('Coper-Self-invoice')}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn :disabled="faturagoster" @click="FaturaHazirla()" flat> 
              <span class="hidden-sm-and-down">
               {{ $t('Find-Invoice-Template') }}
               </span>
              <v-icon right dark>insert_drive_file</v-icon>
            </v-btn>

            <v-menu bottom>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>

                <v-tooltip v-show="fatsecgoster" bottom>
                  <v-list-tile slot="activator" :disabled="!sayfayetki.Delete" @click="faturaTaslakSil()">
                    <v-list-tile-title> {{ $t('Delete-Invoice-Template') }} </v-list-tile-title>
                  </v-list-tile>
                  <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Delete"> {{ $t('Delete-Invoice-Template') }} </span>
                </v-tooltip>

                <v-tooltip v-show="!fatsecgoster" bottom>
                  <v-list-tile slot="activator" :disabled="!sayfayetki.Save" @click="yeniSablonEkle()">
                    <v-list-tile-title>Yeni Şablon Ekle</v-list-tile-title>
                  </v-list-tile>
                  <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Save">Yeni Şablon Ekle</span>
                </v-tooltip>





                <v-tooltip v-show="!fatsecgoster" bottom>
                  <v-list-tile slot="activator" :disabled="!sayfayetki.Update" @click="faturaSablonDuzenle()">
                    <v-list-tile-title> {{ $t('Edit-Selected-Template') }} </v-list-tile-title>
                  </v-list-tile>
                  <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Update"> {{ $t('Edit-Selected-Template') }} </span>
                </v-tooltip>



                <v-tooltip v-show="fatsecgoster" bottom>
                  <v-list-tile slot="activator" :disabled="!sayfayetki.Delete" @click="faturaSablonSil()">
                    <v-list-tile-title> {{ $t('Delete-Selected-Template') }} </v-list-tile-title>
                  </v-list-tile>
                  <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Delete">Seçili Şablonu Sill</span>
                </v-tooltip>



                <v-tooltip v-show="!fatsecgoster" bottom>
                  <v-list-tile slot="activator" :disabled="!sayfayetki.Update" @click="faturaSablonDipDuzenle()">
                    <v-list-tile-title>{{  $t('Edit-Bottom-Explanation-Selected-Template') }}</v-list-tile-title>
                  </v-list-tile>
                  <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                  <span v-if="sayfayetki.Update">{{  $t('Edit-Bottom-Explanation-Selected-Template') }}</span>
                </v-tooltip>


              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>
        <v-flex v-if="!dizaynView" xs12 md12 sm12>
          <v-layout row wrap>
            <v-flex pa-2 xs12 sm12>
              <v-form ref="formfatura" v-model="valid" lazy-validation>
                <v-card flat>
                  <v-layout row wrap>

                    <v-flex xs12 pt-2 pr-2 pl-2 sm12 md12>
                      <v-layout row wrap>

                        <v-flex v-show="fatsecgoster" xs12 sm3 md3>
                          <v-layout row wrap class="pl-1 pr-1 project overdue">
                            <v-flex md12 xs12 sm12>
                              <v-layout row wrap>
                                <v-flex md12 xs12 sm12>
                                  <v-select :items="itemsFaturaList" v-model="secilenFatura" :label="$t('Select-Invoice')"
                                    hide-details="">
                                  </v-select>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                        <v-flex md3 v-show="!fatsecgoster" xs12 sm3>
                          <v-select :items="itemsBelgeTipi" v-model="FaturaKesimOzellik.Tip" :label="$t('File-Type')"
                            hide-details="" item-text="text" item-value="id">
                          </v-select>
                        </v-flex>

                        <v-flex md3 v-show="!fatsecgoster" xs12 sm3>
                          <v-select :items="itemsFaturaTipi" v-model="FaturaKesimOzellik.FaturaTip" :label="$t('Invoice-Type')"
                            hide-details="" item-text="text" item-value="id">
                          </v-select>
                        </v-flex>


                        <v-flex md3 xs12 sm12>
                          <v-select :items="itemsFaturaSablon" v-show="!fatsecgoster"
                            :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="faturaSablon" :label="$t('Invoice-Template')"
                            hide-details="">
                          </v-select>
                        </v-flex>

                        <v-flex v-show="!fatsecgoster" sm12 md3 xs12>
                          <kurcomp v-model="para" :kurtarihi="getDateNow()"></kurcomp>
                        </v-flex>


                      </v-layout>
                    </v-flex>

                    <v-flex xs12 pr-2 pl-2 sm12 md12>
                      <v-layout row wrap>


                        <v-flex v-show="!fatsecgoster" pb-2 xs12 sm12 md6>
                          <copertevkifatkodu v-model="tevkifatkodu"></copertevkifatkodu>
                        </v-flex>


                        <v-flex v-show="!fatsecgoster" pb-2 sm6 md3 xs6>
                          <v-checkbox hide-details v-model="HerPnrTekFatura" :label="$t('Include-all-PNR-single-invoice')">
                          </v-checkbox>
                        </v-flex>
                        <v-flex v-show="!fatsecgoster" pb-2 sm6 md3 xs6>
                          <v-checkbox hide-details v-model="VadeTarihiHesapla" label="Vade Tarihi Otomatik Hesaplansın">
                          </v-checkbox>
                        </v-flex>

                      </v-layout>
                    </v-flex>

                  </v-layout>
                </v-card>
              </v-form>
            </v-flex>

            <v-flex v-if="faturagoster==true" xs10 pa-2 sm10>
              <v-card flat>
                <v-layout justify-end row wrap>

                  <v-flex xs12 pa-3 sm12>

                    <div id="printJS-form">

                      <table style="page-break-after: always;" width="100%">

                        <tr>

                          <td colspan=8 align=center style="padding-top:10px;padding-bottom:10px;">
                            <span class="black--text title"> {{ $t('COPER-SALES-INVOICE') }} </span>
                          </td>
                        </tr>

                        <tr>

                          <td colspan="8">
                            <v-layout class="no-print" justify-end>
                              <v-btn color="info" flat @click="baslikGuncelle()">
                                <v-icon small>edit</v-icon> &nbsp; {{$t('Edit-Header-Information')}}
                              </v-btn>
                            </v-layout>

                            <br />
                            <br />

                          </td>
                        </tr>
                        <tr style="align-top:40;" align=left>
                          <td align="left" style="width:35%">
                            <span class=".subheading font-weight-bold">
                              {{faturaitems.Musteri.Unvan1}}</span>
                          </td>

                          <td style="width:30%">
                          </td>

                          <td style="width:20%">
                            &nbsp;
                          </td>

                          <td style="text-align:end; width:10%" align=left>
                            <span class=".subtitle-2 font-weight-bold">
                              {{faturaitems.FaturaTarihi | dateformat}} </span>

                          </td>

                        </tr>

                        <tr>
                          <td>
                            <span class="subheading font-weight-bold">
                              {{faturaitems.Musteri.Unvan2}}
                            </span>
                          </td>
                          <td>

                          </td>
                          <td style="text-align:end;">
                            {{$t('Maturity-Date')}}: </td>
                          <td style="text-align:end;">
                            <span class=".subtitle-2 font-weight-">
                              {{faturaitems.VadeTarihi | dateformat}} </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="body-2 font-weight-regular">
                              {{faturaitems.Musteri.Adres1}}</span>

                          </td>
                          <td>

                          </td>
                          <td style="text-align:end;">
                            Fatura S/N:
                          </td>
                          <td style="text-align:end;">
                            {{faturaitems.FaturaSeri}}- {{faturaitems.FaturaNo}}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="body-2 font-weight-regular">
                              {{faturaitems.Musteri.Adres2}}&nbsp;
                            </span>
                          <td>

                          </td>
                          <td>

                          </td>
                          <td>

                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="body-2 font-weight-regular">
                              {{faturaitems.Musteri.Ilce_Il}} </span>
                          <td>

                          </td>
                          <td>

                          </td>
                          <td>

                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="body-2 font-weight-regular">
                              {{faturaitems.Musteri.VergiDairesi}}/
                              {{faturaitems.Musteri.VergiNo_TCKimlikNo}} </span>
                          <td>

                          </td>
                          <td>

                          </td>
                          <td>

                          </td>
                        </tr>
                        <tr>
                          <td>
                            <br />
                            <br />
                            <br /> <br />

                          </td>
                        </tr>

                        <tr style="padding-top:50px;" v-for="item in faturaitems.Kalemler" :key="item.id">
                          <td colspan=4>
                            <table width="100%">
                              <tr colspan=4>
                                <td style="margin-top:20px;">

                                  <span class="  subheading"> {{item.Aciklama}}</span>
                                  <v-icon class="no-print" small @click="EditSatirAciklama(item)">
                                    edit
                                  </v-icon>
                                </td>

                                <td style="width:10%">
                                  <span class="  subheading"> </span>
                                </td>
                                <td style="width:20%">
                                  <span class="  subheading"> </span>
                                </td>
                                <td style="text-align:end;width:10%">
                                  <span class="  subheading">
                                    {{item.Tutar | moneyformat}}&nbsp;{{getparaBirimi(faturaitems.ParaBirimi)}}</span>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td colspan=4>
                            <table width="100%">
                              <tr colspan=4>
                                <td style="margin-top:20px;">
                                  <span class="  subheading"> </span>
                                  <v-divider></v-divider>
                                </td>

                                <td style="width:10%">
                                  <span class="  subheading"> </span>
                                  <v-divider></v-divider>
                                </td>
                                <td style="width:40%">
                                  <v-divider></v-divider>
                                </td>
                                <td style="text-align:end;width:10%">
                                  <v-divider></v-divider>

                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td colspan=4>
                            <table width="100%">
                              <tr colspan=4>
                                <td style="margin-top:20px;">
                                  <span class="  subheading"> </span>
                                </td>

                                <td style="width:10%">
                                  <span class="  subheading"> </span>
                                </td>
                                <td style="width:40%">
                                  <span class="  subheading">  {{ $t('Detail-Total') }} : </span>
                                </td>
                                <td style="text-align:end;width:10%">
                                  <span class="  subheading">
                                    {{faturaitems.Toplamlar.Tutar | moneyformat}}&nbsp;{{getparaBirimi(faturaitems.ParaBirimi)}}</span>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr v-for="itemiskonto in faturaitems.Toplamlar.IskontoToplamlari" :key="itemiskonto.id">
                          <td colspan=4>
                            <table width="100%">
                              <tr colspan=4>
                                <td style="margin-top:20px;">
                                  <span class="  subheading"> </span>
                                </td>

                                <td style="width:10%">
                                  <span class="  subheading"> </span>
                                </td>
                                <td style="width:40%">
                                  <span class="  subheading"> %{{itemiskonto.KDVOrani}} &nbsp;
                                    {{ $t('Discount') }}  
                                  </span>
                                </td>
                                <td style="text-align:end;width:10%">
                                  <span class="  subheading">
                                    {{itemiskonto.Tutar | moneyformat}}&nbsp;{{getparaBirimi(faturaitems.ParaBirimi)}}</span>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr v-for="itemiskdv in faturaitems.Toplamlar.KDVToplamlari" :key="itemiskdv.id">
                          <td colspan=4>
                            <table width="100%">
                              <tr colspan=4>
                                <td style="margin-top:20px;">
                                  <span class="  subheading"> </span>
                                </td>

                                <td style="width:10%">
                                  <span class="  subheading"> </span>
                                </td>
                                <td style="width:40%">
                                  <span class="  subheading"> %{{itemiskdv.KDVOrani}} &nbsp;
                                    KDV Matrah: {{itemiskdv.Matrah | moneyformat}} </span>
                                </td>
                                <td style="text-align:end;width:10%">
                                  <span class="  subheading">
                                    {{itemiskdv.KDVTutari | moneyformat}}&nbsp;{{getparaBirimi(faturaitems.ParaBirimi)}}</span>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                          <tr v-for="itemistevkifat in faturaitems.Toplamlar.TevkifatToplamlari" :key="itemistevkifat.TevkifatID">
                          <td colspan=4>
                            <table width="100%">
                              <tr colspan=4>
                                <td style="margin-top:20px;">
                                  <span class="  subheading"> </span>
                                </td>

                                <td style="width:10%">
                                  <span class="  subheading"> </span>
                                </td>
                                <td style="width:40%">
                                  <span class="  subheading"> {{itemistevkifat.Tevkifat.intField}}/10 &nbsp;
                                    Tevkifat </span>
                                </td>
                                <td style="text-align:end;width:10%">
                                  <span class="  subheading">
                                    {{itemistevkifat.Tutar | moneyformat}}&nbsp;{{getparaBirimi(faturaitems.ParaBirimi)}}</span>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>


                        <tr>
                          <td colspan=4>
                            <table width="100%">
                              <tr colspan=4>
                                <td style="margin-top:20px;">
                                  <span class="  subheading"> </span>
                                </td>

                                <td style="width:10%">
                                  <span class="  subheading"> </span>
                                </td>
                                <td style="width:40%">
                                  <v-divider></v-divider>
                                </td>
                                <td style="text-align:end;width:10%">
                                  <v-divider></v-divider>

                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td colspan=4>
                            <table width="100%">
                              <tr colspan=4>
                                <td style="margin-top:20px;">
                                  <span class="  subheading"> </span>
                                </td>

                                <td style="width:10%">
                                  <span class="  subheading"> </span>
                                </td>
                                <td style="width:40%">
                                  <span class="  subheading"> {{ $t('Grand-Total') }} : </span>
                                </td>
                                <td style="text-align:end;width:10%">
                                  <span class="  subheading">
                                    {{faturaitems.Toplamlar.NetTutar | moneyformat}}&nbsp;{{getparaBirimi(faturaitems.ParaBirimi)}}</span>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <br />
                            <br />

                          </td>
                        </tr>

                        <tr style="padding-top:20px;margin-top:10px;">

                          <td colspan=4>
                            <table width="100%">
                              <tr v-for="itemsaciklama in faturaitems.DipAciklamalar" :key="itemsaciklama.id">
                                <td>

                                  {{itemsaciklama.Aciklama}}
                                  <v-icon small class="no-print" @click="EditSatirAciklama2(itemsaciklama)">
                                    edit
                                  </v-icon>
                                </td>
                                <td>
                                </td>
                                <td>

                                </td>

                              </tr>

                            </table>

                          </td>

                        </tr>

                        <tr>
                          <td colspan="8">
                            <span class="grey--text caption"> {{getDateNow() | dateformat}}
                              {{getdatetimenow()}}</span>
                          </td>
                        </tr>

                      </table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

            <v-flex v-if="faturagoster==true" xs2 pa-2 sm2>
              <v-card flat>
                <v-layout row wrap>

                  <v-flex xs12 pa-3 sm12>
                    <v-layout row wrap>

                      <!--
                      <v-flex xs12 sm12>
                        <v-btn block v-if="faturagoster" :disabled="!faturagoster" @click="FaturaTaslakUpdate()"
                          color="info" outline>
                          <v-icon small>save</v-icon> Taslağı Kaydet
                        </v-btn>

                      </v-flex>
                      -->
                      <v-flex xs12 sm12>
                        <v-btn block v-if="faturagoster" :disabled="!faturagoster" @click="FaturaTaslakUpdateOnayla()"
                          :loading="loading" color="info" outline>
                          <v-icon small>check_circle_outlinef</v-icon>  {{ $t('Invoice-the-Template') }}
                        </v-btn>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <v-btn block v-if="faturagoster" :disabled="!faturagoster" @click="denemeyazdir('printJS-form')"
                          color="info" outline>
                          <v-icon small>find_in_page</v-icon>  {{ $t('Template-Previewing') }} 
                        </v-btn>
                      </v-flex>
                          <v-flex xs12 sm12>
                        <v-btn block  @click="EditSatirAciklama3()"
                          color="info" outline>
                          <v-icon small>add</v-icon> Dip Açıkklama Ekle
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

          </v-layout>
        </v-flex>

        <v-flex xs12 v-if="dizaynView && dizaynViewType==1" pa-2 sm12 md12>

          <v-flex xs12 pa-2 sm12 md12>
            <v-card flat>

              <v-layout row wrap>
                <v-flex xs6 sm6 md6>
                  <v-layout fill-height row align-center>
                    <span pa-1 class=" font-weight-regular grey--text title"> &nbsp; 
                      {{ $t('Edit-Template-Item-Explanation') }}
                    </span>
                  </v-layout>
                </v-flex>
                <v-flex xs6 sm6 md6>
                  <v-layout justify-end>
                    <v-btn color="info" slot="activator" @click="iptal()" flat>
                      <span class="hidden-sm-and-down"> {{$t("cancel_button")}}
                      </span>
                      <v-icon right dark>cancel</v-icon>
                    </v-btn>
                    <v-tooltip bottom>
                      <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="kalemDizaynKaydet()"
                        flat>
                        <span class="hidden-sm-and-down">  {{ $t('Update-Design') }} 
                        </span>
                        <v-icon right dark>save</v-icon>
                      </v-btn>
                      <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                      <span v-if="sayfayetki.Update"> {{ $t('Update-Design') }} </span>
                    </v-tooltip>

                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

          </v-flex>

          <v-layout row wrap>

            <v-flex xs9 pa-2 md9 sm9>
              <v-form ref="formsaticidizayn" v-model="valid2" lazy-validation>
                <v-card flat>
                  <v-layout row wrap>
                    <v-flex pa-2 md3 xs3 sm12>
                      <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="faturaSablon" :label="$t('Template-Name')"
                        hide-details="">
                      </v-text-field>
                    </v-flex>

                    <v-flex pa-2 md3 xs3 sm12>
                      <v-select :items="itemssaticitipi" item-text="Aciklama" item-value="Kod"
                        v-model="Dizayn.SaticiTip" :label="$t('Seller-Type')" hide-details="">
                      </v-select>
                    </v-flex>
                    <v-flex pa-2 md3 xs3 sm12>
                      <v-select :items="xsltitems" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="dizaynData.XsltId"
                        clearable item-text="XsltAciklama" item-value="FaturaId" :label="$t('Select-xslt-File')"></v-select>
                    </v-flex>

                    <v-flex pa-2 md3 xs3 sm12>
                      <reportbrosablon :rules="[v => !!v || $t('Mandatory-Areas')]" ref="reportbrosablon"
                        dizayngrupadi="Fatura" v-model="dizaynData.ReportBroId"
                        objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
                    </v-flex>

                    <v-flex pa-2 xs12 md12 sm12>
                      <v-textarea v-if="dizaynView" rows="10" :label="$t('Invoice-Explanation-Template')"
                        v-model="dizaynData.KalemAciklamaSablonu[kayitvarmi].AciklamaSablonu" id="textalan"
                        name="textalan" hide-details=""></v-textarea>
                    </v-flex>
                  </v-layout>

                </v-card>
              </v-form>
            </v-flex>

            <v-flex xs3 pa-2 md3 sm3>
              <v-card flat>
                <v-flex xs12 md12 sm12>
                  <draggable element="span" v-model="dizaynData.KalemAciklamaFieldList" v-bind="dragOptions"
                    :move="onMove">
                    <transition-group name="no" class="list-group" tag="ul">
                      <v-list v-for="element in dizaynData.KalemAciklamaFieldList" :key="element.FieldName" subheader>
                        <v-list-tile>
                          <v-flex xs12 md12 sm12>
                            <v-icon @click="ItemAktar(element.FieldName)" color="green">arrow_back_ios
                            </v-icon>
                            <span class="grey--text subheading"> {{element.FieldName}}</span>
                          </v-flex>
                          <v-list-tile-action>
                            <v-btn icon ripple>
                              <v-icon color="grey">drag_handle
                              </v-icon>
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>
                      </v-list>
                    </transition-group>
                  </draggable>

                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>

        </v-flex>

        <v-flex xs12 v-if="dizaynView && dizaynViewType==2" pa-2 sm12 md12>

          <v-flex xs12 pa-2 sm12 md12>
            <v-card flat>

              <v-layout row wrap>
                <v-flex xs6 sm6 md6>
                  <v-layout fill-height row align-center>
                    <span pa-1 class=" font-weight-regular grey--text title"> &nbsp; Kalem Açıklama Şablon
                      Düzenle</span>
                  </v-layout>
                </v-flex>
                <v-flex xs6 sm6 md6>
                  <v-layout justify-end>
                    <v-btn color="info" slot="activator" @click="iptal()" flat>
                      <span class="hidden-sm-and-down"> {{$t("cancel_button")}}
                      </span>
                      <v-icon right dark>cancel</v-icon>
                    </v-btn>
                    <v-tooltip bottom>
                      <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="kalemDizaynKaydet()"
                        flat>
                        <span class="hidden-sm-and-down">  {{ $t('Update-Design') }} 
                        </span>
                        <v-icon right dark>save</v-icon>
                      </v-btn>
                      <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                      <span v-if="sayfayetki.Update"> {{$t('Update-Design') }} </span>
                    </v-tooltip>

                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

          </v-flex>

          <v-layout row wrap>

            <v-flex xs9 pa-2 md9 sm9>
              <v-form ref="formsaticidizayn" v-model="valid2" lazy-validation>
                <v-card flat>
                  <v-flex pa-2 md4 xs4 sm4>
                    <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="faturaSablon" :label="$t('Template-Name')"
                      hide-details="">
                    </v-text-field>
                  </v-flex>

                  <v-flex pa-2 xs12 md12 sm12>
                    <v-textarea v-if="dizaynView" rows="10" :label="$t('Invoice-Bottom-Explanation-Template')"
                      v-model="dizaynData.DipAciklamaSablonu" id="textalanDip" name="textalan" hide-details="">
                    </v-textarea>
                  </v-flex>
                </v-card>
              </v-form>
            </v-flex>

            <v-flex xs3 pa-2 md3 sm3>
              <v-card flat>
                <v-flex xs12 md12 sm12>
                  <draggable element="span" v-model="dizaynData.DipAciklamaFieldList" v-bind="dragOptions"
                    :move="onMove">
                    <transition-group name="no" class="list-group" tag="ul">
                      <v-list v-for="element in dizaynData.DipAciklamaFieldList" :key="element.FieldName" subheader>
                        <v-list-tile>
                          <v-flex xs12 md12 sm12>
                            <v-icon @click="ItemAktarDip(element.FieldName)" color="green">arrow_back_ios
                            </v-icon>
                            <span class="grey--text subheading"> {{element.FieldName}}</span>
                          </v-flex>
                          <v-list-tile-action>
                            <v-btn icon ripple>
                              <v-icon color="grey">drag_handle
                              </v-icon>
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>
                      </v-list>
                    </transition-group>
                  </draggable>

                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>

        </v-flex>

      </v-layout>
    </v-card>
    <div>

      <v-dialog v-model="SatirDialog" max-width="500px">
        <v-card>
          <v-card-text>
            <v-container>

              <v-text-field v-model="editedItem.Aciklama" :label="$t('Invoice-Line')"></v-text-field>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="SatirDialog2" max-width="500px">
        <v-card>
          <v-card-text>
            <v-container>
              <v-text-field v-model="editedItem2.Aciklama" :label="$t('Bottom-line-Explanation')"></v-text-field>
            </v-container>
          </v-card-text>
          <v-card-actions v-if="SatirDialogOzel">
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="ozelAciklamaEkle(editedItem2.Aciklama)">Ekle</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



      <v-dialog v-if="BaslikDialog" v-model="BaslikDialog" persistent min-width="450px" max-width="450px">
        <v-card color="grey lighten-5">

          <v-card-text>

            <v-tabs style="width:100%;" dark="" v-model="active" color="blue darken-3" slot="extension" slider->
              <v-tabs-slider></v-tabs-slider>
              <v-tab href='#0'>
               {{$t("tab_general")}}
              </v-tab>
              <v-tab-item :id="'0'" style="width:100%; height:600px;">
                <v-layout row="" wrap="">
                  <v-flex xs12 sm12 md12>

                    <v-layout row wrap>

                      <v-flex xs6 md6 v-if="manuelSeri" sm12>
                        <v-autocomplete maxlength=3 label="Fatura Seri" id="serientervalue" @blur="seriEnter()"
                          @keyup.enter="seriEnter()" :items="itemsfaturaseri" v-model="yenibaslikBilgi.FaturaSeri">
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs6 md6 v-if="!manuelSeri" sm12>
                        <v-select :label="$t('Invoice-Serial')" :items="itemsfaturaseri" v-model="yenibaslikBilgi.FaturaSeri">
                        </v-select>
                      </v-flex>



                      <v-flex xs6 md6 sm12>
                        <v-text-field hide-details v-model="yenibaslikBilgi.FaturaNo" :label="$t('Invoice-No')">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6 md6 sm12>
                        <tarihcomp :etiket="$t('Invoice-Date')" :aktifmi="true" :detaygizle="true"
                          v-bind:defaultvalue="'no'" v-bind:value="yenibaslikBilgi.FaturaTarihi"
                          v-model="yenibaslikBilgi.FaturaTarihi">
                        </tarihcomp>
                      </v-flex>
                      <v-flex xs6 md6 sm12>
                        <tarihcomp :etiket="$t('Maturity-Date')" :aktifmi="true" :detaygizle="true" v-bind:defaultvalue="'no'"
                          v-bind:value="yenibaslikBilgi.VadeTarihi" v-model="yenibaslikBilgi.VadeTarihi">
                        </tarihcomp>
                      </v-flex>
                      <v-flex xs12 md12 sm12>
                        <v-text-field hide-details v-model="yenibaslikBilgi.Musteri.Unvan1" :label="$t('Title_label'+'1')">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md12 sm12>
                        <v-text-field hide-details v-model="yenibaslikBilgi.Musteri.Unvan2" :label="$t('Title_label'+'2')">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md12 sm12>
                        <v-text-field hide-details v-model="yenibaslikBilgi.Musteri.Adres1" :label="$t('Address_label') +'1'">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md12 sm12>
                        <v-text-field hide-details v-model="yenibaslikBilgi.Musteri.Adres2" :label="$t('Address_label') + '2'">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md12 sm12>
                        <v-text-field hide-details v-model="yenibaslikBilgi.Musteri.Ilce_Il" :label="$t('Province_label')">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md12 sm12>
                        <v-text-field hide-details v-model="yenibaslikBilgi.Musteri.VergiDairesi" :label="$t('Taxcenter_label')">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md12 sm12>
                        <v-text-field hide-details v-model="yenibaslikBilgi.Musteri.VergiNo_TCKimlikNo"
                          :label="$t('Tax-TC-No')">
                        </v-text-field>
                      </v-flex>

                      <v-flex xs12 md12 sm12>
                        <v-text-field hide-details v-model="yenibaslikBilgi.Musteri.EMail"
                          :label="$t('EMail-Mandatory-Electronic-E-Archive-Invoices')">
                        </v-text-field>
                      </v-flex>

                      <v-flex xs12 md12 sm12>
                        <v-text-field hide-details v-model="yenibaslikBilgi.Musteri.PerFirstName"
                          :label="$t('Name-Mandatory-eInvoice-eArchives-issued-TC')">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md12 sm12>
                        <v-text-field hide-details maxlength="50" v-model="yenibaslikBilgi.Musteri.PerFamilyName"
                          :label="$t('Surname-Mandatory-for-eInvoice-eArchives-issued-TC')">
                        </v-text-field>
                      </v-flex>

                    </v-layout>





                  </v-flex>


                </v-layout>

              </v-tab-item>

              <v-tab v-if="FaturaKesimOzellik.Tip==0" href='#1' ripple>
                E-Arşiv
              </v-tab>

              <v-tab-item v-if="FaturaKesimOzellik.Tip==0" :id="'1'" style="width:100%; height:600px; ">
                <v-form ref="formearsiv" v-model="validearsiv" lazy-validation>
                  <v-layout row="" wrap="">
                    <v-flex xs12 sm12 md12>
                      <v-select :items="odemesekli" @change="faturaSeriListGetir()" v-model="EArsivBilgiClass.tip"
                        hide-details="" clearable item-text="text" item-value="value" :label="$t('E-archive-Internet-Sales')">
                      </v-select>
                    </v-flex>


                    <v-flex xs12 sm12 md12>
                      <v-select :items="gonderimsekli" :rules="[v => !!v || $t('Mandatory-Areas')]"
                        v-model="EArsivBilgiClass.gonderimSekli" hide-details="" item-text="text" item-value="value"
                        :label="$t('E-archive-Delivery-Method')">
                      </v-select>
                    </v-flex>


                    <v-flex xs12 v-if="EArsivBilgiClass.tip==1" sm12 md12>
                      <tarihcomp :rules="[v => !!v || $t('Mandatory-Areas')]" :etiket="$t('E-archive-Payment-Date')"
                        v-bind:defaultvalue="'ok'" v-bind:value="EArsivBilgiClass.internetSatisBilgi.odemeTarihi"
                        v-model="EArsivBilgiClass.internetSatisBilgi.odemeTarihi"></tarihcomp>
                    </v-flex>

                    <v-flex v-if="EArsivBilgiClass.tip==1" xs12 sm12 md12>
                      <webadresicomp :rules="[v => !!v || $t('Mandatory-Areas')]"
                        v-model="EArsivBilgiClass.internetSatisBilgi.webAdresiID">
                      </webadresicomp>
                    </v-flex>



                    <v-flex xs12 v-if="EArsivBilgiClass.tip==1" sm12 md12>
                      <v-select :items="odemesekli1" :rules="[v => !!v || $t('Mandatory-Areas')]"
                        v-model="EArsivBilgiClass.internetSatisBilgi.odemeSekli" hide-details="" clearable
                        item-text="text" item-value="value" :label="$t('E-archive-Payment-Method')">
                      </v-select>
                    </v-flex>


                    <v-flex xs12 sm12 v-if="EArsivBilgiClass.tip==1" md12>
                      <odemearacicomp :tabdeger="'59'" v-model="EArsivBilgiClass.internetSatisBilgi.odemeAracisiAdiID">
                      </odemearacicomp>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-form ref="formdigeraciklama" v-model="validdigeraciklama" lazy-validation>
                  <v-layout row wrap>

                    <v-flex xs12 sm12 v-if="EArsivBilgiClass.tip==1" md12>
                      <odemesekillericomp :rules="[v => !!v || $t('Mandatory-Areas')]"
                        v-model="EArsivBilgiClass.internetSatisBilgi.odemeSekliDigerAciklamaID">
                      </odemesekillericomp>
                    </v-flex>


                  </v-layout>
                </v-form>
              </v-tab-item>

            </v-tabs>



          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" flat="flat" @click.native="BaslikDialog = false">{{$t("cancel_button")}}</v-btn>
            <v-btn color="info" flat @click.native="faturabilgiValidate()">Tamam</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog persistent v-model="yeniSablonDialog" max-width="450px">
        <v-card>
          <v-card-text>
            <v-container>
              <v-form ref="formyenisablon" v-model="validyenisablon" lazy-validation>
                <v-layout row wrap>
                  <v-flex xs12 md12 sm12>
                    <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" hide-details v-model="yeniSablonAdi"
                      :label="$t('Template-Name')"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" flat="flat" @click.native="yeniSablonDialog = false">{{$t("cancel_button")}}</v-btn>
            <v-btn color="info" flat @click.native="yeniSablonKaydet()">{{$t("save_button")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>

    </div>

  </div>
</template>

<script>
  import rez from "../coper/rezervasyon";
  import printJS from 'print-js'
  import kur from "@/components/app/coper/comp/kur.vue";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import genelaramakod from "@/components/app/coper/comp/genelaramakod.vue";
  import tarihcomp from '../customcomp/tarihim'
  import parainput from '../customcomp/parainput'
  import yuzdeinput from '../customcomp/yuzdeinput'
  import helpers from "@/components/app/customcomp/helpers.js"
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"
  import draggable from "vuedraggable";
  import tool from "../coper/tools";
  import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
  import loadingcomp from "@/components/app/customcomp/loadingcomp"
  import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
  import auth from '../../../api/auth'
  import webadresicomp from "@/components/app/bilet/partpage/webadresicomp.vue"
  import odemesekillericomp from "@/components/app/bilet/partpage/odemesekillericomp.vue"
  import odemearacicomp from "@/components/app/bilet/partpage/odemearacicomp.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import kurcomp from "@/components/app/coper/component/kurcomp.vue";
  import copertevkifatkodu from "@/components/app/coper/component/copertevkifatkodu.vue";

  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import faturaheaderdialog from "@/components/app/coper/comp/faturaheaderdialog.vue";

  export default {

    components: {
      kur,
      genelarama,
      genelaramakod,
      tarihcomp,
      geneltipara,
      parainput,
      yuzdeinput,
      onaydialog,
      draggable,
      loadingcomp,
      reportbrosablon,
      hatadialog,
      webadresicomp,
      odemesekillericomp,
      odemearacicomp,
      yetkidialog,
      kurcomp,
      copertevkifatkodu,
      faturaheaderdialog

    },
    watch: {
      'secilenFatura': function (val) {
        this.FaturaTaslakUpdate();
        this.taslakFaturaGetirIDGoster(val)

      },
      'FaturaKesimOzellik.Tip': function (val) {
        this.sablonGetir();
      },
      'FaturaKesimOzellik.FaturaTur': function (val) {
        this.sablonGetir();
      },
      'FaturaKesimOzellik.FaturaTip': function (val) {
        this.sablonGetir();
      },

      'Dizayn.SaticiTip': function (val) {
        this.getSaticiDizayn(val)
      },

      isDragging(newValue) {
        if (newValue) {
          this.delayedDragging = true;
          return;
        }
        this.$nextTick(() => {
          this.delayedDragging = false;
        });
      }

    },

    props: ["value"],
    computed: {

      draggingInfo() {
        return this.dragging ? "under drag" : "";
      },

      dragOptions() {
        return {
          animation: 0,
          group: "description",
          disabled: !this.editable,
          ghostClass: "ghost"
        };
      },
      listString() {
        return JSON.stringify(this.list, null, 2);
      },
      list2String() {
        return JSON.stringify(this.list2, null, 2);
      }
    },

    data() {
      return {
        ozelAciklama:[],
        tevkifatkodu: {
          id: null,
          intField: null,
          isim: null,
          kod: null,
          tip: null
        },
        VadeTarihiHesapla:true,
        HerPnrTekFatura: false,
        para: {
          paraBirimi: 'TL',
          kur: 1,
        },
        active: 0,
        validearsiv: true,
        validdigeraciklama: true,
        dialogearsiv: false,
        gonderimsekli: [{
            text: this.$t('Paper'),
            value: '0'
          },
          {
            text: this.$t('Electronic'),
            value: '1'
          }
        ],
        odemesekli: [{
            text: this.$t('Normal-Sales'),
            value: 0
          },
          {
            text: this.$t('Internet-Sales'),
            value: 1
          }
        ],
        odemesekli1: [{
            text: this.$t('Credit-Debit-Card'),
            value: '0'
          },
          {
            text: 'EFT-' + this.$t('Transfer-v3'),
            value: '1'
          },
          {
            text: this.$t('Cash-on-delivery'),
            value: '2'
          },
          {
            text: this.$t('Payment-Intermediary'),
            value: '3'
          },
          {
            text: this.$t('Other'),
            value: '4'
          }
        ],
        fatsecgoster: false,
        yeniSablonDialog: false,
        validyenisablon: true,
        yeniSablonAdi: null,

        itemsFaturaList: [],
        AktifSatisFaturasi: {},
        secilenFatura: null,

        xsltitems: [],
        itemsfaturaseri: [],
        kayitvarmi: 0,
        dizaynViewType: 1,
        denemestatus: false,
        loading: false,

        Dizayn: {
          AciklamaSablonu: '',
          SaticiTip: 1,
          ReportBroId: null,
          XsltId: null
        },

        itemssaticitipi: rez.SaticiTip,
        dragging: false,
        dizaynData: [],
        dizaynView: false,
        dizaynAdi: null,
        editable: true,

        id: 3,
        name: "handle",
        display: "Handle",

        isDragging: false,
        delayedDragging: false,

        sayfayetki: {
          Screen: true,
          Update: true,
          Save: true,
          Delete: true,
          Status: true,
          Message: null,
          islem: 0,
        },
        valid: true,
        faturaSablon: null,
        itemsFaturaSablon: [],
        FaturaKesimOzellik: {
          Tip: 0,
          FaturaTur: 0,
          FaturaTip: 2,
          KesimTip: 1
        },

        itemsBelgeTipi: [{
            id: 0,
            text: this.$t("Bill"),
          },
          {
             id: 1,
             text: this.$t('Receipt')
          },
          // {
          //   id: 2,
          //   text: 'Proforma'
          // }, 
          {
            id: 3,
            text: this.$t('E-Invoice')
          }
        ],

        itemsFaturaTuru: [{
            id: 0,
            text: this.$t('Domestic-v2')
          },
          {
            id: 1,
            text: this.$t('Outgoing')
          },
          {
            id: 2,
            text: this.$t('Incoming')
          }
        ],

        itemsFaturaTipi: [{
            id: 0,
            text: this.$t('Summarize-Per-Current-Code')
          },
          {
            id: 1,
            text: 'PNR Noya Göre Özet'
          },
          {
            id: 2,
            text: this.$t('Summarize-Per-Sales-Item')
          }, {
            id: 3,
            text: this.$t('Details')
          }, {
            id: 4,
            text: this.$t('Summarize-Per-Seller-Type')
          }, {
            id: 5,
            text: this.$t('Summarize-per-Seller-Code')
          }
        ],

        itemsKesimTipi: [{
            id: 0,
            text: 'None'
          },
          {
            id: 1,
            text: 'Satis'
          },
          {
            id: 2,
            text: this.$t('Commission')
          }, {
            id: 3,
            text: 'Iade'
          }, {
            id: 4,
            text: this.$t('Receipt')
          }, {
            id: 5,
            text: 'SatisEFatura'
          }
        ],

        yenibaslikBilgi: {
          rez: null,
          FaturaKesimOzellik: {},
          KesimTip: null,
          Id: null,
          GrupId: null,
          FaturaNo: null,
          FaturaSeri: null,
          FaturaTarihi: null,
          VadeTarihi: null,
          ParaBirimi: null,

          Musteri: {
            Unvan1: null,
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo_TCKimlikNo: null,
            Ilce_Il: null,
            CariKod: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,

          },

          Toplamlar: null,
          DipAciklamalar: [],
          Kalemler: [],
          TopluFaturaId: null,
          GenelFaturaId: null,
          Kur: null,
          ReportBroId: null,
          XsltId: null,
          EArsiv: {
            gonderimSekli: null,
            internetSatisBilgi: {
              odemeAracisiAdiID: null,
              odemeSekli: null,
              odemeSekliDigerAciklamaID: null,
              odemeTarihi: null,
              webAdresiID: null
            }
          }
        },
        EArsivBilgiClass: {
          tip: 0,
          gonderimSekli: '0',
          internetSatisBilgi: {
            odemeAracisiAdiID: null,
            odemeSekli: null,
            odemeSekliDigerAciklamaID: null,
            odemeTarihi: null,
            webAdresiID: null
          }
        },

        Aciklamalar: {
          Aciklama1: null,
          Aciklama2: null,
          Not: null
        },
        pnr: null,
        faturagoster: false,
        valid2: true,
        faturaitems: [],

        SatirDialog: false,
        editedItem: {},
        BaslikDialog: false,
        SatirDialog2: false,
        SatirDialogOzel:false,
        SatirDialogOzelUpdate:false,
        SatirOzelUpdate:{
          id:0,
          Aciklama:null
        },
        SatirOzelAciklama:null,
        editedItem2: {},

        dialogShow: false,

        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        manuelSeri: false

      };
    },

    created() {},
    methods: {
      seriEnter(v) {

        var indexno = this.itemsfaturaseri.indexOf(document.getElementById('serientervalue').value)

        if (indexno == -1) {
          this.itemsfaturaseri.push(document.getElementById('serientervalue').value)
          this.yenibaslikBilgi.FaturaSeri = document.getElementById('serientervalue').value
        }
      },
      getparaBirimi(v) {
        return helpers.getparabirimiDefault(v);
      },

      faturaSeriListGetir() {
        this.yenibaslikBilgi.FaturaSeri = null
        let params = null
        //seri listelerken  Internet satış değilse Internet bilgisini null gönderebilirmisin
        if (this.EArsivBilgiClass.tip == 1) {
          params = {
            CariKod: this.faturaitems.Musteri.CariKod,
            ArsivBilgisi: {
              gonderimSekli: this.EArsivBilgiClass.gonderimSekli,
              internetSatisBilgi: {
                odemeAracisiAdiID: this.EArsivBilgiClass.internetSatisBilgi.odemeAracisiAdiID,
                odemeSekli: this.EArsivBilgiClass.internetSatisBilgi.odemeSekli,
                odemeSekliDigerAciklamaID: this.EArsivBilgiClass.internetSatisBilgi.odemeSekliDigerAciklamaID,
                odemeTarihi: this.EArsivBilgiClass.internetSatisBilgi.odemeTarihi,
                webAdresiID: this.EArsivBilgiClass.internetSatisBilgi.webAdresiID
              }
            },
            Tip : this.FaturaKesimOzellik.Tip
          }
        } else {
          params = {
            CariKod: this.faturaitems.Musteri.CariKod,
            ArsivBilgisi: {
              gonderimSekli: this.EArsivBilgiClass.gonderimSekli,
              internetSatisBilgi: null,
              
            },
            Tip : this.FaturaKesimOzellik.Tip
          }
        }

        tool.http_post(this, 'FaturaSeriList', params).then(
          response => {


            if (response.body.Status == true) {

              if (response.body.data == [] || response.body.data == null) {
                this.manuelSeri = true
              } else {
                if (response.body.data[0] != null && response.body.data[0] != '') {
                  this.manuelSeri = false
                } else {
                  this.manuelSeri = true
                }
              }
              this.itemsfaturaseri = response.body.data
            } else {
              this.manuelSeri = true
              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
            }


          },

          response => {
            this.HataYonetimi(response, params, 'Fatura Seri Listesi getirilemedi');
          }

        );
      },
      FaturaHazirla() {
        this.denemestatus = true

        var faturalistesi = JSON.parse(window.localStorage.getItem('container_toplufatura'));

        var pnrlist = []
        faturalistesi.forEach(element => {
          if (this.VadeTarihiHesapla==true)
{
  var pnrprm=[];
          pnrprm.push(element.PNR_No);
          let params = {
          PNR_List:pnrprm,
          FaturaTarihi:element.FaturaTarihi
        }
  tool.http_post(this, 'VadeTarihiHesapla', params).then(
          response => {
            if (response.body.Status == true) {
              element.VadeTarihi = response.body.data[0].VadeTarihi
            } else {
              
            }
          }
          )
}
          var kayit = {
            PNR_No: element.PNR_No,
            VadeTarihi: element.VadeTarihi,
            FaturaTarihi: element.FaturaTarihi
          }
          pnrlist.push(kayit)
        });

        let params1 = {
          PNR_List: pnrlist,
          FaturaKesimOzellik: {
            Tip: this.FaturaKesimOzellik.Tip,
            FaturaTur: this.FaturaKesimOzellik.FaturaTur,
            FaturaTip: this.FaturaKesimOzellik.FaturaTip,
            KesimTip: 1
          },
          ParaBirimi: this.para.paraBirimi,
          Kur: this.para.kur,
          Sablon: this.faturaSablon,
          HerPnrTekFatura: this.HerPnrTekFatura,
          TevkifatID: this.tevkifatkodu,
         
        }

        tool.http_post(this, 'TopluSatisFaturasiHazirla', params1).then(
          response => {

            this.itemsFaturaList = []

            if (response.body.Status == true) {

              response.body.data.TaslakIdList.forEach(element => {
                this.itemsFaturaList.push(element)
              });

              this.AktifSatisFaturasi = response.body.data.IlkFatura
              this.secilenFatura = response.body.data.IlkFatura.Id
              this.fatsecgoster = true

            } else {
              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
            }
            this.denemestatus = false
          },

          response => {
            this.HataYonetimi(response, params1, 'Komisyon Faturası Getirilemedi');
            this.denemestatus = false

          }

        );
      },
      yeniSablonEkle() {
        this.yeniSablonDialog = true
      },
      sablonGetir() {
        let params = {
          FaturaKesimOzellik: {
            Tip: this.FaturaKesimOzellik.Tip,
            FaturaTur: this.FaturaKesimOzellik.FaturaTur,
            FaturaTip: this.FaturaKesimOzellik.FaturaTip,
            KesimTip: 1
          }
        }

        tool.http_post(this, 'FaturaSablonList', params).then(
          response => {
            if (response.body.Status == true) {
              this.itemsFaturaSablon = response.body.data
            } else {
              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
            }
          },

          response => {
            this.HataYonetimi(response, params, this.$t('Template-List-not-Found'));
          }

        );
      },
      HataYonetimi(response, request, baslik) {
        this.loading = false;
        if (response.status === 500) //Internal Server Error
        {
          this.$refs.hatadialog.open(response, request, baslik);
        } else {
          this.text1 = 'Service Unavailable -' + baslik;
          this.snackbar = true;
        }
      },
      yeniSablonKaydet() {
        if (this.$refs.formyenisablon.validate()) {
          this.denemestatus = true
          let params = {
            FaturaKesimOzellik: this.FaturaKesimOzellik,
            SablonAdi: this.yeniSablonAdi,
            DipAciklamaSablonu: null, // this.dizaynData.DipAciklamaSablonu,
            KalemAciklamaSablonu: [], // this.dizaynData.KalemAciklamaSablonu,
            ReportBroId: null, // this.dizaynData.ReportBroId,
            XsltId: null, // this.dizaynData.XsltId
          }

          tool.http_post(this, 'FaturaSablonSave', params).then(
            response => {
              if (response.body.Status == true) {
                this.yeniSablonAdi = null
                this.dizaynData = response.body.data
                this.dizaynView = false
                this.faturagoster = false

                let params1 = {
                  FaturaKesimOzellik: {
                    Tip: this.FaturaKesimOzellik.Tip,
                    FaturaTur: this.FaturaKesimOzellik.FaturaTur,
                    FaturaTip: this.FaturaKesimOzellik.FaturaTip,
                    KesimTip: 1
                  }
                }

                tool.http_post(this, 'FaturaSablonList', params1).then(
                  response => {
                    if (response.body.Status == true) {
                      this.itemsFaturaSablon = response.body.data
                      this.text1 = "Kayıt edildi."
                      this.snackbar = true
                      this.yeniSablonDialog = false
                    } else {
                      this.text1 = response.body.ErrorList[0]
                      this.snackbar = true
                    }
                    this.denemestatus = false
                  },

                  response => {
                    this.HataYonetimi(response, params1, 'Fatura Sablon Listesi getirilemedi');

                  }

                );

              } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
                this.dizaynView = true

              }
              this.denemestatus = false

            },

            response => {

              this.HataYonetimi(response, params, this.$t('Invoice-not-Saved-Template'));

              this.dizaynView = true
              this.denemestatus = false
            }

          );

        }

      },

      kalemDizaynKaydet() {
        if (this.$refs.formsaticidizayn.validate()) {
          this.denemestatus = true
          let params = {
            FaturaKesimOzellik: this.FaturaKesimOzellik,
            SablonAdi: this.faturaSablon,
            DipAciklamaSablonu: this.dizaynData.DipAciklamaSablonu,
            KalemAciklamaSablonu: this.dizaynData.KalemAciklamaSablonu,
            ReportBroId: this.dizaynData.ReportBroId,
            XsltId: this.dizaynData.XsltId
          }

          tool.http_post(this, 'FaturaSablonSave', params).then(
            response => {
              if (response.body.Status == true) {
                this.dizaynData = response.body.data
                this.dizaynView = false
                this.faturagoster = false

                let params1 = {
                  FaturaKesimOzellik: {
                    Tip: this.FaturaKesimOzellik.Tip,
                    FaturaTur: this.FaturaKesimOzellik.FaturaTur,
                    FaturaTip: this.FaturaKesimOzellik.FaturaTip,
                    KesimTip: 1
                  }
                }

                tool.http_post(this, 'FaturaSablonList', params1).then(
                  response => {
                    if (response.body.Status == true) {
                      this.itemsFaturaSablon = response.body.data
                      this.text1 = "Kayıt edildi."
                      this.snackbar = true
                    } else {
                      this.text1 = response.body.ErrorList[0]
                      this.snackbar = true
                    }
                  },

                  response => {
                    this.HataYonetimi(response, params1, 'Fatura Sablon Listesi getirilemedi');

                  }

                );

              } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
                this.dizaynView = true

              }
              this.denemestatus = false

            },

            response => {

              this.HataYonetimi(response, params, this.$t('Invoice-not-Saved-Template'));

              this.dizaynView = true
              this.denemestatus = false
            }

          );

        } else {
          this.text1 = this.$t('Select-Template')
          this.snackbar = true
        }

      },
      iptal() {
        this.dizaynView = false
        this.kayitvarmi = -1
      },
      getSaticiDizayn(val) {

        if (val != null && val != undefined) {
          var index = this.dizaynData.KalemAciklamaSablonu.map(function (e) {
            return e.SaticiTip;
          }).indexOf(val);
          if (index != -1) {
            this.kayitvarmi = index
          }

        }


      },
      ItemAktar(val) {
        var cursorPos = document.getElementById('textalan').selectionStart
        var textBefore = this.dizaynData.KalemAciklamaSablonu[this.kayitvarmi].AciklamaSablonu.substring(0,
          cursorPos);
        var textAfter = this.dizaynData.KalemAciklamaSablonu[this.kayitvarmi].AciklamaSablonu.substring(cursorPos,
          this
          .dizaynData.KalemAciklamaSablonu[this.kayitvarmi].AciklamaSablonu.length);
        this.dizaynData.KalemAciklamaSablonu[this.kayitvarmi].AciklamaSablonu = textBefore + val + textAfter;
      },
      ItemAktarDip(val) {
        var cursorPos = document.getElementById('textalanDip').selectionStart
        var textBefore = this.dizaynData.DipAciklamaSablonu.substring(0, cursorPos);
        var textAfter = this.dizaynData.DipAciklamaSablonu.substring(cursorPos, this.dizaynData.DipAciklamaSablonu
          .length);
        this.dizaynData.DipAciklamaSablonu = textBefore + val + textAfter;
      },
      faturaSablonDuzenle() {
        if (this.$refs.formfatura.validate()) {
          this.denemestatus = true
          this.Dizayn.SaticiTip = 1
          this.dizaynViewType = 1

          let params = {
            FaturaKesimOzellik: this.FaturaKesimOzellik,
            SablonAdi: this.faturaSablon
          }

          tool.http_post(this, 'FaturaSablonLoad', params).then(
            response => {
              if (response.body.Status == true) {
                this.dizaynData = response.body.data
                this.dizaynView = true
                this.getSaticiDizayn(1);
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                let paramsxslt = {
                  CompanyCode: credentials.SirketKodu
                }
                this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', paramsxslt, {
                  headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                  }
                }).then((response) => {
                  this.xsltitems = response.body
                }, (response) => {
                  if (response.status === 0) {
                    this.progress = false
                    this.text1 = 'Service Unavailable-InvoiceXsltTableList'
                    this.snackbar = true
                  } else {
                    this.HataYonetimi(response, paramsxslt, 'InvoiceXsltTableList işlemi başarısız');
                  }
                })

              } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
                this.dizaynView = false

              }
              this.denemestatus = false

            },

            response => {
              this.HataYonetimi(response, params, 'Fatura Şablon Getirilemedi');
              this.dizaynView = false
              this.denemestatus = false
            }

          );

        } else {
          this.text1 = this.$t('Select-Template')
          this.snackbar = true
        }

      },
      faturaSablonDipDuzenle() {
        if (this.$refs.formfatura.validate()) {
          this.denemestatus = true

          this.dizaynViewType = 2

          let params = {
            FaturaKesimOzellik: this.FaturaKesimOzellik,
            SablonAdi: this.faturaSablon
          }

          tool.http_post(this, 'FaturaSablonLoad', params).then(
            response => {
              if (response.body.Status == true) {
                this.dizaynData = response.body.data
                this.dizaynView = true

              } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
                this.dizaynView = false

              }
              this.denemestatus = false

            },

            response => {
              this.HataYonetimi(response, params, 'Fatura Şablon Getirilemedi');
              this.dizaynView = false
              this.denemestatus = false

            }

          );

        } else {
          this.text1 = this.$t('Select-Template')
          this.snackbar = true
        }

      },
      onMove({
        relatedContext,
        draggedContext
      }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return ((!relatedElement || !relatedElement.fixed) && !draggedElement.fixed);

      },
      faturaTaslakSil() {
        this.$refs.onaydialog.open('Bu kayıtı silmek istediğinize eminmisiniz', 1).then(sonuc => {

          if (sonuc == true) {

            let params = {
              PNR_No: this.AktifSatisFaturasi.Kalemler[0].PNR_No
            }

            tool.http_post(this, "PNRFaturaTaslagiSil", params).then(
              response => {

                if (response.body.Status == true) {
                  this.text1 = 'Taslak silindi.'
                  this.snackbar = true

                } else {

                  this.text1 = response.body.ErrorList[0]
                  this.snackbar = true
                }
              },
              response => {
                this.HataYonetimi(response, params, 'Fatura Taslağı Silinemedi');
              }
            );

          }
        });

      },
      faturaSablonSil() {
        if (this.$refs.formfatura.validate()) {

          this.$refs.onaydialog.open('Bu kayıtı silmek istediğinize emin misiniz?', 1).then(sonuc => {

            if (sonuc == true) {
              let params = {
                FaturaKesimOzellik: this.FaturaKesimOzellik,
                SablonAdi: this.faturaSablon
              }

              tool.http_post(this, "FaturaSablonDelete", params).then(
                response => {

                  if (response.body.Status == true) {
                    this.text1 = 'Fatura Şablonu silindi.'
                    this.snackbar = true

                    let params = {
                      FaturaKesimOzellik: {
                        Tip: this.FaturaKesimOzellik.Tip,
                        FaturaTur: this.FaturaKesimOzellik.FaturaTur,
                        FaturaTip: this.FaturaKesimOzellik.FaturaTip,
                        KesimTip: 1
                      }
                    }

                    tool.http_post(this, 'FaturaSablonList', params).then(
                      response => {
                        if (response.body.Status == true) {
                          this.itemsFaturaSablon = response.body.data
                        } else {
                          this.text1 = response.body.ErrorList[0]
                          this.snackbar = true
                        }
                      },

                      response => {
                        this.HataYonetimi(response, params, 'Sablon Listesi getirilemedi ');
                      }

                    );

                  } else {

                    this.text1 = response.body.ErrorList[0]
                    this.snackbar = true
                  }
                },
                response => {
                  this.HataYonetimi(response, params, 'Fatura Şablonu Silinemedi');
                }
              );

            }
          });

        } else {
          this.text1 = this.$t('Select-Template')
          this.snackbar = true
        }
      },
      faturabilgiValidate() {


        var earsivv = {
          gonderimSekli: null,
          internetSatisBilgi: {
            odemeAracisiAdiID: null,
            odemeSekli: null,
            odemeSekliDigerAciklamaID: null,
            odemeTarihi: null,
            webAdresiID: null
          }
        }



        this.yenibaslikBilgi.EArsiv = earsivv
        this.yenibaslikBilgi.FaturaKesimOzellik = this.FaturaKesimOzellik;


        if (this.FaturaKesimOzellik.Tip == 0) {

          if (this.EArsivBilgiClass.tip == 1) {

            if (this.$refs.formearsiv.validate()) {

              if (this.EArsivBilgiClass.internetSatisBilgi.odemeSekli == 4) {

                if (this.$refs.formdigeraciklama.validate()) {

                  // if (this.EArsivBilgiClass.internetSatisBilgi.odemeSekliDigerAciklamaID != null) {
                  this.yenibaslikBilgi.EArsiv.internetSatisBilgi.odemeTarihi = this.EArsivBilgiClass
                    .internetSatisBilgi
                    .odemeTarihi
                  this.yenibaslikBilgi.EArsiv.internetSatisBilgi.webAdresiID = this.EArsivBilgiClass
                    .internetSatisBilgi
                    .webAdresiID
                  this.yenibaslikBilgi.EArsiv.gonderimSekli = this.EArsivBilgiClass.gonderimSekli

                  this.yenibaslikBilgi.EArsiv.internetSatisBilgi.odemeSekli = this.EArsivBilgiClass
                    .internetSatisBilgi
                    .odemeSekli

                  this.yenibaslikBilgi.EArsiv.internetSatisBilgi.odemeAracisiAdiID = this.EArsivBilgiClass
                    .internetSatisBilgi.odemeAracisiAdiID
                  this.yenibaslikBilgi.EArsiv.internetSatisBilgi.odemeSekliDigerAciklamaID = this.EArsivBilgiClass
                    .internetSatisBilgi.odemeSekliDigerAciklamaID

                  let params = {
                    FaturaTaslak: this.yenibaslikBilgi
                  }



                  tool.http_post(this, "FaturaTaslakValidate", params).then(
                    response => {

                      if (response.body.Status == true) {
                        this.AktifSatisFaturasi = this.yenibaslikBilgi
                        this.faturaitems = this.yenibaslikBilgi

                        this.BaslikDialog = false
                      } else {

                        this.text1 = response.body.ErrorList[0]
                        this.snackbar = true
                      }
                    },
                    response => {
                      this.HataYonetimi(response, params, 'Taslak doğruluk kontrolü yapılamadı');
                    }
                  );


                } else {
                  //  this.text1 = "E-Arşiv ödeme şekli açıklama seçiniz.."
                  //  this.snackbar = true
                }


              } else {

                this.yenibaslikBilgi.EArsiv.internetSatisBilgi.odemeTarihi = this.EArsivBilgiClass
                  .internetSatisBilgi
                  .odemeTarihi
                this.yenibaslikBilgi.EArsiv.internetSatisBilgi.webAdresiID = this.EArsivBilgiClass
                  .internetSatisBilgi
                  .webAdresiID
                this.yenibaslikBilgi.EArsiv.gonderimSekli = this.EArsivBilgiClass.gonderimSekli
                this.yenibaslikBilgi.EArsiv.internetSatisBilgi.odemeSekli = this.EArsivBilgiClass.internetSatisBilgi
                  .odemeSekli
                this.yenibaslikBilgi.EArsiv.internetSatisBilgi.odemeAracisiAdiID = this.EArsivBilgiClass
                  .internetSatisBilgi.odemeAracisiAdiID
                this.yenibaslikBilgi.EArsiv.internetSatisBilgi.odemeSekliDigerAciklamaID = this.EArsivBilgiClass
                  .internetSatisBilgi.odemeSekliDigerAciklamaID

                let params = {
                  FaturaTaslak: this.yenibaslikBilgi
                }

                tool.http_post(this, "FaturaTaslakValidate", params).then(
                  response => {



                    if (response.body.Status == true) {
                      this.AktifSatisFaturasi = this.yenibaslikBilgi
                      this.faturaitems = this.yenibaslikBilgi

                      this.BaslikDialog = false
                    } else {

                      this.text1 = response.body.ErrorList[0]
                      this.snackbar = true
                    }
                  },
                  response => {
                    this.HataYonetimi(response, params, 'Taslak doğruluk kontrolü yapılamadı');
                  }
                );

              }


            } else {
              this.text1 = this.$t('Please-fill-required-fields');
              this.snackbar = true
              this.active = "1"
            }
          } else {

            this.yenibaslikBilgi.EArsiv.internetSatisBilgi = null

            let params = {
              FaturaTaslak: this.yenibaslikBilgi
            }

            tool.http_post(this, "FaturaTaslakValidate", params).then(
              response => {

                if (response.body.Status == true) {
                  this.AktifSatisFaturasi = this.yenibaslikBilgi
                  this.faturaitems = this.yenibaslikBilgi

                  this.BaslikDialog = false
                } else {

                  this.text1 = response.body.ErrorList[0]
                  this.snackbar = true
                }
              },
              response => {
                this.HataYonetimi(response, params, 'Taslak doğruluk kontrolü yapılamadı');
              }
            );

          }

        } else {

          this.yenibaslikBilgi.EArsiv.internetSatisBilgi = null
          let params = {
            FaturaTaslak: this.yenibaslikBilgi
          }

          tool.http_post(this, "FaturaTaslakValidate", params).then(
            response => {

              if (response.body.Status == true) {
                this.AktifSatisFaturasi = this.yenibaslikBilgi
                this.faturaitems = this.yenibaslikBilgi

                this.BaslikDialog = false
              } else {

                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
              }
            },
            response => {
              this.HataYonetimi(response, params, 'Taslak doğruluk kontrolü yapılamadı');
            }
          );


        }



      },
      baslikGuncelle() {
         //this.$refs.faturaheaderdialog.open(this.faturaitems).then(sonuc => {});
         this.$refs.faturaheaderdialog.open(this.faturaitems,this.FaturaKesimOzellik);

      },
      odeyenTarafGetir(val) {
        return rez.OdeyenTarafGetir(val);
      },
      getdatetimenow() {

        var timenow = helpers.getTimeNow();

        return String(timenow)
      },

      gunhesapla(val) {

        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const firstDate = new Date(val.donem1);
        const secondDate = new Date(val.donem2);
        const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
        return diffDays

      },

      denemeyazdir(divName) {

        var mywindow = window.open('', 'PRINT', 'height=500,width=700');

        mywindow.document.write('</head>');
        mywindow.document.write('<style>');
        //yazdırılmayacak alanlar için css ekliyorum
        mywindow.document.write('@media print{.no-print {display:none !important;}}');
        mywindow.document.write('</style>');
        mywindow.document.write('<body >');
        mywindow.document.write(document.getElementById(divName).innerHTML);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;

      },
      voucheryazdir() {

        var prm = {
          printable: this.someJSONdata,
          properties: ['name', 'email', 'phone'],
          type: 'json'
        }

        //'printJS-form', 'html'
        printJS('printJS-form', 'html');

      },
      EditSatirAciklama(val) {
        this.editedItem = val;
        this.SatirDialog = true;

      },
      EditSatirAciklama2(val) {
        this.SatirDialogOzel = false;
        this.editedItem2 = val;
        this.SatirDialog2 = true;
      },
      EditSatirAciklama3() {
        let data = {
          id:0,
          Aciklama:null
        };
        this.editedItem2 = data;
        this.SatirDialog2 = true;
        this.SatirDialogOzel = true;
      },
      ozelAciklamaEkle(val){
          let data = {
            Aciklama: val
          };
          this.AktifSatisFaturasi.DipAciklamalar.push(data);
          this.SatirDialog2 = false;
      },

      FaturaTaslakUpdate() {
     
        let params = {
          FaturaTaslak: this.AktifSatisFaturasi
        }
        tool.http_post(this, "FaturaTaslakUpdate", params).then(
          response => {

            if (response.body.Status == true) {

            } else {

              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
              this.faturagoster = false

            }
          },
          response => {

            this.HataYonetimi(response, params, this.$t('Template-not-saved'));
            this.faturagoster = false

          }
        );
      },

      FaturaTaslakUpdateOnayla() {
         
  
        


        let params = {
          FaturaTaslak: this.AktifSatisFaturasi
        }
        this.denemestatus = true;
        tool.http_post(this, "FaturaTaslakUpdate", params).then(
          response => {

            if (response.body.Status == true) {

              let params1 = {
                TaslakIdList: this.itemsFaturaList
              }

              tool.http_post(this, 'SatisFaturasiTaslakOnayla', params1).then(
                response => {
                  if (response.body.Status == true) {

                    this.text1 = "Fatura taslağınız onaylandı."
                    this.snackbar = true
                    window.localStorage.removeItem('container_toplufatura')

                  } else {
                    this.text1 = response.body.ErrorList[0]
                    this.snackbar = true
                  }
                  this.denemestatus = false;
                },

                response => {
                  this.text1 = 'Hata Oluştu, tekrar deneyiniz'
                  this.snackbar = true
                  this.denemestatus = false;

                }

              );


            } else {
              this.text1 = this.$t('Invoice-not-approved-since-your-invoice-template-updated-please-try-again')
              this.snackbar = true
              this.denemestatus = false
              this.faturagoster = false
              this.denemeyazdir = false
            }
          },
          response => {

            this.HataYonetimi(response, params, 'Taslak Güncellenemedi.');
            this.faturagoster = false
            this.denemestatus = false

          }
        );
      },

      taslakFaturaGetirGoster() {

        let pnrlist = []

        let pnr = {
          PNR_No: this.AktifSatisFaturasi.Kalemler[0].PNR_No,
          VadeTarihi: null
        }

        pnrlist.push(pnr)

        let params = {
          PNR_List: pnrlist,
          FaturaKesimOzellik: this.FaturaKesimOzellik,
          Sablon: this.faturaSablon
        }

        tool.http_post(this, "SatisFaturasiHazirla", params).then(
          response => {

            if (response.body.Status == true) {
              this.faturaitems = response.body.data
              this.Aciklamalar = response.body.data.Aciklamalar
              this.faturagoster = true
            } else {

              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
              this.faturagoster = false
            }
          },
          response => {

            this.HataYonetimi(response, params, this.$t('Invoice-not-prepared'));

            this.faturagoster = false

          }
        );

      },

      taslakFaturaGetirIDGoster(val) {

        let params = {
          Id: val
        }

        tool.http_post(this, 'FaturaTaslakOku', params).then(
          response => {

            if (response.body.Status == true) {

              this.Aciklamalar = response.body.data.Aciklamalar
              this.AktifSatisFaturasi = response.body.data
              this.faturaitems = response.body.data

              this.faturagoster = true

            } else {

              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
              this.faturagoster = false
            }

          },

          response => {
            this.HataYonetimi(response, params, this.$t('Invoice-not-prepared'));
            this.faturagoster = false
          }

        );

      },

      KisiTipToStr(tip) {
        return rez.KisiTipToStr(tip);
      },
      getDateNow() {
        return helpers.getDateNow();
      },
      PansiyonTipToStr(tip) {
        return rez.PansiyonTipToStr(tip);
      },
      SaticiTipToStr(tip) {
        return rez.SaticiTipToStr(tip);
      },
      setSelected(v) {
        this.selected = v;
      },
      setDialogShow(v) {
        this.dialogShow = v;
      },

      close() {
        this.value.dialogShow = false;
        setTimeout(() => {
          this.value.kalem = Object.assign({}, rez.Kalem());

          this.value.editedIndex = -1;
        }, 300);
      },

      modalOk() {
        this.value.kalem.kisiSira = [];
        for (var i = 0; i < this.selected.length; i++) {
          this.value.kalem.kisiSira.push(this.selected[i].kisiSira);
        }

        if (this.value.editedIndex > -1) {
          Object.assign(
            this.value.Rez.kalemler[this.value.editedIndex],
            this.value.kalem
          );
        } else {
          this.value.Rez.kalemler.push(this.value.kalem);
        }
        this.close();
      }
    },

    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    mounted() {

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {


        var faturalistesi = JSON.parse(window.localStorage.getItem('container_toplufatura'));

        if (faturalistesi != null) {

          if (faturalistesi.length != 0) {


            this.denemestatus = true

            let params = {
              FaturaKesimOzellik: {
                Tip: this.FaturaKesimOzellik.Tip,
                FaturaTur: this.FaturaKesimOzellik.FaturaTur,
                FaturaTip: this.FaturaKesimOzellik.FaturaTip,
                KesimTip: 1
              }
            }

            tool.http_post(this, 'FaturaSablonList', params).then(
              response => {
                if (response.body.Status == true) {
                  this.itemsFaturaSablon = response.body.data
                  this.faturaSablon = this.itemsFaturaSablon[0]
                } else {
                  this.text1 = response.body.ErrorList[0]
                  this.snackbar = true
                }
                this.denemestatus = false
              },

              response => {
                this.HataYonetimi(response, params, this.$t('Template-List-not-Found'));
                this.denemestatus = false
              }

            );

          } else {
            this.text1 = this.$t('No-records-found-invoiced-You-redirected-Coper-Joint-Invoice-Selection')
            this.snackbar = true

            setTimeout(function () {

                var link = '#/fatura/copertoplufatura'
                window.open(link, '_self');
              }

              .bind(this), 6000)
          }

        } else {
          this.text1 = this.$t('Wrong-process-you-being-redirected-Coper-Invoice-Selection')
          this.snackbar = true

          setTimeout(function () {

              var link = '#/fatura/copertoplufatura'
              window.open(link, '_self');
            }

            .bind(this), 6000)
        }




      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }
    },


    filters: {
      truefalse: function (t) {
        if (t == true) {
          return 'Dahil'
        } else {
          return 'Hariç'
        }
      },
      kont: function (t) {
        if (t == true) {
          return 'Evet'
        } else {
          return 'Hayır'
        }
      },
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },

    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    }

  };
</script>

<style>
  @media print {
    .no-print {
      display: none !important;
    }
  }
</style>